function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from 'ant-design-vue/es/checkbox';
import Tooltip from 'ant-design-vue/es/tooltip';
import Icon from 'ant-design-vue/es/icon';

import TableExpand from './expand';
import TableSlot from './slot';

var __script__ = {
  name: 'TableCell',
  components: {
    TableExpand: TableExpand,
    TableSlot: TableSlot,
    Checkbox: Checkbox,
    Tooltip: Tooltip,
    Icon: Icon
  },
  inject: ['tableRoot'],
  props: {
    prefixCls: String,
    row: Object,
    column: Object,
    naturalIndex: Number, // index of rebuildData
    index: Number, // _index of data
    checked: Boolean,
    disabled: Boolean,
    expanded: Boolean,
    fixed: {
      type: [Boolean, String],
      default: false
    }
  },
  data: function data() {
    return {
      renderType: '',
      uid: -1,
      context: this.$parent.$parent.$parent.currentContext,
      showTooltip: false // 鼠标滑过overflow文本时，再检查是否需要显示
    };
  },

  computed: {
    classes: function classes() {
      var _ref;

      return [this.prefixCls + '-cell', (_ref = {}, _defineProperty(_ref, this.prefixCls + '-hidden', !this.fixed && this.column.fixed && (this.column.fixed === 'left' || this.column.fixed === 'right')), _defineProperty(_ref, this.prefixCls + '-cell-ellipsis', this.column.ellipsis || false), _defineProperty(_ref, this.prefixCls + '-cell-with-expand', this.renderType === 'expand'), _defineProperty(_ref, this.prefixCls + '-cell-with-selection', this.renderType === 'selection'), _ref)];
    },
    expandCls: function expandCls() {
      return [this.prefixCls + '-cell-expand', _defineProperty({}, this.prefixCls + '-cell-expand-expanded', this.expanded)];
    }
  },
  methods: {
    toggleSelect: function toggleSelect() {
      this.$parent.$parent.$parent.toggleSelect(this.index);
    },
    toggleExpand: function toggleExpand() {
      this.$parent.$parent.$parent.toggleExpand(this.index);
    },
    handleClick: function handleClick() {
      // 放置 Checkbox 冒泡
    },
    handleTooltipIn: function handleTooltipIn() {
      var $content = this.$refs.content;
      if ($content) {
        this.showTooltip = $content.scrollWidth > $content.offsetWidth;
      }
    },
    handleTooltipOut: function handleTooltipOut() {
      this.showTooltip = false;
    },
    isEmpty: function isEmpty(val) {
      if (typeof val === 'undefined' || val === null || val === '') {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    if (this.column.type === 'index') {
      this.renderType = 'index';
    } else if (this.column.type === 'selection') {
      this.renderType = 'selection';
    } else if (this.column.type === 'html') {
      this.renderType = 'html';
    } else if (this.column.type === 'expand') {
      this.renderType = 'expand';
    } else if (this.column.customRender) {
      this.renderType = 'render';
    } else if (this.column.slot) {
      this.renderType = 'slot';
    } else {
      this.renderType = 'normal';
    }
  }
};

var render = function render() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "cell",
    class: _vm.classes
  }, [_vm.renderType === 'index' ? [_c('span', [_vm._v(_vm._s(_vm.column.indexMethod ? _vm.column.indexMethod(_vm.row) : _vm.naturalIndex + 1))])] : _vm._e(), _vm._v(" "), _vm.renderType === 'selection' ? [_c('Checkbox', {
    attrs: {
      "checked": _vm.checked,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.toggleSelect
    },
    nativeOn: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClick($event);
      }
    }
  })] : _vm._e(), _vm._v(" "), _vm.renderType === 'html' ? [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.row[_vm.column.key])
    }
  })] : _vm._e(), _vm._v(" "), _vm.renderType === 'normal' ? [_vm.column.tooltip ? [_c('Tooltip', {
    attrs: {
      "title": _vm.row[_vm.column.key],
      "visible": _vm.showTooltip,
      "mouseEnterDelay": 0.1,
      "overlayClassName": _vm.prefixCls + "-cell-tooltip"
    }
  }, [_c('span', {
    ref: "content",
    class: _vm.prefixCls + "-cell-tooltip-content",
    on: {
      "mouseenter": _vm.handleTooltipIn,
      "mouseleave": _vm.handleTooltipOut
    }
  }, [_vm._v(_vm._s(_vm.isEmpty(_vm.row[_vm.column.key]) ? _vm.tableRoot.placeholder : _vm.row[_vm.column.key]))])])] : _c('span', [_vm._v(_vm._s(_vm.isEmpty(_vm.row[_vm.column.key]) ? _vm.tableRoot.placeholder : _vm.row[_vm.column.key]))])] : _vm._e(), _vm._v(" "), _vm.renderType === 'expand' && !_vm.row._disableExpand ? [_c('div', {
    class: _vm.expandCls,
    on: {
      "click": _vm.toggleExpand
    }
  }, [_c('Icon', {
    attrs: {
      "type": "right"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.renderType === 'render' ? [_vm.column.tooltip ? [_c('Tooltip', {
    attrs: {
      "visible": _vm.showTooltip,
      "mouseEnterDelay": 0.1,
      "overlayClassName": _vm.prefixCls + "-cell-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('table-expand', {
          attrs: {
            "row": _vm.row,
            "column": _vm.column,
            "index": _vm.index,
            "render": _vm.column.customRender
          }
        })];
      },
      proxy: true
    }], null, false, 2489165644)
  }, [_vm._v(" "), _c('div', {
    ref: "content",
    class: _vm.prefixCls + "-cell-tooltip-content",
    on: {
      "mouseenter": _vm.handleTooltipIn,
      "mouseleave": _vm.handleTooltipOut
    }
  }, [_c('table-expand', {
    attrs: {
      "row": _vm.row,
      "column": _vm.column,
      "index": _vm.index,
      "render": _vm.column.customRender
    }
  })], 1)])] : _c('table-expand', {
    attrs: {
      "row": _vm.row,
      "column": _vm.column,
      "index": _vm.index,
      "render": _vm.column.customRender
    }
  })] : _vm._e(), _vm._v(" "), _vm.renderType === 'slot' ? [_vm.column.tooltip ? [_c('Tooltip', {
    attrs: {
      "visible": _vm.showTooltip,
      "mouseEnterDelay": 0.1,
      "overlayClassName": _vm.prefixCls + "-cell-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('table-slot', {
          attrs: {
            "row": _vm.row,
            "column": _vm.column,
            "index": _vm.index
          }
        })];
      },
      proxy: true
    }], null, false, 2938176563)
  }, [_vm._v(" "), _c('div', {
    ref: "content",
    class: _vm.prefixCls + "-cell-tooltip-content",
    on: {
      "mouseenter": _vm.handleTooltipIn,
      "mouseleave": _vm.handleTooltipOut
    }
  }, [_c('table-slot', {
    attrs: {
      "row": _vm.row,
      "column": _vm.column,
      "index": _vm.index
    }
  })], 1)])] : _c('table-slot', {
    attrs: {
      "row": _vm.row,
      "column": _vm.column,
      "index": _vm.index
    }
  })] : _vm._e()], 2);
};
var staticRenderFns = [];
var __template__ = { render: render, staticRenderFns: staticRenderFns };

export default Object.assign({}, __script__, __template__);